import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconAgenticCoding: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconAgenticCoding"><Path d="M18.5 11L19.75 14.25L23 15.5V16.5L19.75 17.75L18.5 21H17.5L16.25 17.75L13 16.5V15.5L16.25 14.25L17.5 11H18.5Z" fill="currentColor"/><Path d="M10 19H3V17H10V19Z" fill="currentColor"/><Path d="M6 13H3V11H6V13Z" fill="currentColor"/><Path d="M13 13H8V11H13V13Z" fill="currentColor"/><Path d="M13 7H3V5H13V7Z" fill="currentColor"/><Path d="M21 7H15V5H21V7Z" fill="currentColor"/></CentralIconBase>;
});

export default IconAgenticCoding;
